import PropTypes from "prop-types";
import LoginIcon from "./../../resources/login";
import LogoutIcon from "./../../resources/logout";
import "./P2Button.scss";

export default function P2Button(props) {
  const { variant, disabled, startIcon, endIcon, width, isLogin, style, ...others } = props;

  return (
    <button
      type="button"
      className={`${disabled ? getClass(variant) : "btn btn-" + variant} ${variant === "login" ? "btn-primary-2 btn-icon" : ""} ${variant === "text-icon" ? "btn-text-only-content" : ""} ${startIcon || endIcon ? "btn-icon" : ""} ${width && variant !== "button-icon" && "btn-with-width"} d-print-none`}
      disabled={disabled}
      aria-disabled={disabled}
      onClick={props.onClick}
      style={{whiteSpace: "nowrap", width: width? width : "fit-content", height: "48px", ...style}}
      {...others}
    >
      {startIcon && <div style={{display: "flex"}}>{startIcon}</div>}
      {variant === "login" && <div style={{display: "flex"}} className="loginIconContainer">{props.isLogin ? <LoginIcon /> : <LogoutIcon /> }</div>}
      {variant === "list-header" || variant === "tertiary" || startIcon || endIcon ? <span>{props.children}</span> : props.children}
      {endIcon && <div style={{display: "flex"}}>{endIcon}</div>}
    </button>
  );
}

const getClass = (variant) => {
  switch (variant) {
    case "primary-1":
      return "btn btn-secondary";
    case "primary-2":
      return "btn btn-secondary";
    case "login":
      return "btn btn-secondary";
    case "outline-primary":
      return "btn btn-outline-secondary";
    case "link text-decoration-none":
      return "btn btn-link text-decoration-none";
    case "list-header":
      return "btn btn-list-header";
    case "tertiary":
      return "btn btn-tertiary";
    case "text-icon":
      return "btn btn-text-icon";
    case "button-icon":
      return "btn btn-button-icon";
    default:
      return ""
  }
};

P2Button.propTypes = { 
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  startIcon: PropTypes.element,
  endIcon: PropTypes.element,
  width: PropTypes.string,
  // width: PropTypes.oneOfType([
  //   PropTypes.string,
  //   PropTypes.number
  // ]),
  isLogin: PropTypes.bool,
  variant: PropTypes.oneOf([
    "primary-1",
    "primary-2",
    "outline-primary",
    "link text-decoration-none",
    "list-header",
    "tertiary",
    "text-icon",
    "button-icon",
    "login"
  ]),
  style: PropTypes.object,
 };
